export const Routes = {
  index: "/",
  home: "/home",
  register: "/register",
  registerSpouse: "/register-spouse",
	plannerInvite: "/planner-invite",
  login: "/login",
  resetPassword: "/reset-password",
  dashboard: "/dashboard",
  myWeddn: "/my-weddn",
  planner: "/planner",
  plannerWeddings: "/planner/weddings",
  plannerInvitations: "/planner/invitations",
  plannerCalendar: "/planner/calendar",
  plannerTeam: "/planner/team",
  plannerTasks: "/planner/tasks",
  plannerTemplates: "/planner/templates",
  plannerActivity: "/planner/activity",

  // design studio routes
  designs: "/design",
  designEditor: "/design/editor",
  asoEbi: "/aso-ebi",
  loveWall: "/love-wall",

  // not needed again
  // eventPlanner: "/event-planner",
  // yourWeddns: "/event-planner/weddns",
  // editAccessCard: "/edit-access-card",
  // test: "/test",

  //catering
  catering: "/catering",
  cateringCentre: "/catering/centre",

  // guest routes
  guests: "/guests",
  guestsTablePlan: "/guests/tableplan",
  guestsWellWishes: "/guests/wellwishes",
  guestsMessaging: "/guests/messaging",
  guestsPreference: "/guests/preference",
  guestsAccessCards: "/guests/accesscards",
  guestsDeleted: "/guests/deleted",

  // website routes
  website: "/website",
  preWedding: "/website/pre",
  dDay: "/website/dday",
  overview: "/website/overview",
  templates: "/website/templates",
  websiteDesign: "/website/design",
  editWebsite: "/website/edit",
  basicsEdit: "/website/edit/basics",
  loveStoryEdit: "/website/edit/love-story",
  asoEbiEdit: "/website/edit/aso-ebi",
  eventSchedule: "/website/edit/event-schedule",
  galleryEdit: "/website/edit/gallery",
  giftingEdit: "/website/edit/gifting",
  qAndAEdit: "/website/edit/q-and-a",
  weddingPartyEdit: "/website/edit/wedding-party",

  // canonical access card route
  accessCard: "/accesscards",
  legacyAccessCard: "/access-card",
  qrDesign: "/accesscards/design",

  // settings routes
  settings: "/settings",
  CollaborationsSettings: "/settings/collaboration",
  ShareFeedbackSettings: "/settings/share-feedback",
  SubscriptionSettings: "/settings/subscription",
  notFound: "*",

  // messaging routes
  messaging: "/messaging",
  messagingTemplates: "/messaging/templates",
  messagingCreate: "/messaging/create",
  messagingSend: "/messaging/send",
  messagingDetails: "/messaging/:id",

  // notification routes
  notifications: "/notifications",

  // weddnpro subscription routes
  weddnProSubscription: "/weddnpro-subscription",

  // support routes
  faqs: "/faqs",
  support: "/support",
  eventSupport: "/planner/weddings/:id/support",
  messages: "/messages",
  sendMessage: "/send-a-message",

  // event planner routes
  eventPlannerWedding: "/planner/weddings/:id",
  eventPlannerWeddingList: "/planner/weddings",
  eventPlannerDesigns: "/planner/weddings/:id/design",
  eventPlannerDesignEditor: "/planner/weddings/:id/design/editor",
  eventPlannerAsoEbi: "/planner/weddings/:id/aso-ebi",
  eventPlannerLoveWall: "/planner/weddings/:id/love-wall",

  eventPlannerCatering: "/planner/weddings/:id/catering",
  eventPlannerCateringCentre: "/planner/weddings/:id/catering/centre",

  eventPlannerWeddnProSubscription: "/planner/weddings/:id/weddnpro-subscription",
  eventPlannerGuests: "/planner/weddings/:id/guests",
  eventPlannerGuestsTablePlan: "/planner/weddings/:id/guests/tableplan",
  eventPlannerGuestsWellWishes: "/planner/weddings/:id/guests/wellwishes",
  eventPlannerGuestsMessaging: "/planner/weddings/:id/guests/messaging",
  eventPlannerGuestsPreference: "/planner/weddings/:id/guests/preference",
  eventPlannerGuestsAccessCards: "/planner/weddings/:id/guests/accesscards",
  eventPlannerGuestsDeleted: "/planner/weddings/:id/guests/deleted",

  eventPlannerWebsite: "/planner/weddings/:id/website",
  eventPlannerPreWedding: "/planner/weddings/:id/website/pre",
  eventPlannerDDay: "/planner/weddings/:id/website/dday",
  eventPlannerOverview: "/planner/weddings/:id/website/overview",
  eventPlannerTemplates: "/planner/weddings/:id/website/templates",
  eventPlannerWebsiteDesign: "/planner/weddings/:id/website/design",
  eventPlannerEditWebsite: "/planner/weddings/:id/website/edit",
  eventPlannerBasicsEdit: "/planner/weddings/:id/website/edit/basics",
  eventPlannerLoveStoryEdit: "/planner/weddings/:id/website/edit/love-story",
  eventPlannerAsoEbiEdit: "/planner/weddings/:id/website/edit/aso-ebi",
  eventPlannerEventSchedule: "/planner/weddings/:id/website/edit/event-schedule",
  eventPlannerGalleryEdit: "/planner/weddings/:id/website/edit/gallery",
  eventPlannerGiftingEdit: "/planner/weddings/:id/website/edit/gifting",
  eventPlannerQAndAEdit: "/planner/weddings/:id/website/edit/q-and-a",
  eventPlannerWeddingPartyEdit: "/planner/weddings/:id/website/edit/wedding-party",

  eventPlannerSettings: "/planner/weddings/:id/settings",
  eventPlannerCollaborationsSettings: "/planner/weddings/:id/settings/collaboration",
  eventPlannerShareFeedbackSettings: "/planner/weddings/:id/settings/share-feedback",
  eventPlannerSubscriptionSettings: "/planner/weddings/:id/settings/subscription",

  // thingsToDo: "/things-to-do",
  // sendInvites: "/send-invites",
  // setUpWebsite: "/setup-website",
  // accessCards: "/access-cards",
  // lovewall: "/lovewall",
  // weddingParty: "/wedding-party",
  // asoEbi: "/aso-ebi",
};
